const messages = {
  en: {
    translations: {
      common: {
        yes: "Yes",
        no: "No",
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        create: "Create",
        update: "Update",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        loading: "Loading...",
        noData: "No data",
        error: "Error",
        success: "Success",
        warning: "Warning"
      },
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        welcomeBack: "Welcome back",
        subtitle: "Enter your credentials to access your workspace",
        heroTitle: "Manage all your conversations in one place",
        heroDescription:
          "Centralize tickets, messages and customers with a modern, secure and elegant login experience.",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register",
          forgotPassword: "Forgot password?",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
        toasts: {
          loadError: "Could not load the company list.",
          saveSuccess: "Operation completed successfully!",
          saveError: "Could not complete the operation. Check if a company with the same name already exists or if the fields were filled correctly.",
          deleteSuccess: "Operation completed successfully!",
          deleteError: "Could not complete the operation."
        }
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        filters: {
          show: "Show Filters",
          hide: "Hide Filters",
        },
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        sections: {
          indicators: "Indicators",
          satisfactionSurvey: "Satisfaction Survey",
          attendances: "Attendances",
          ratingIndex: "Rating Index",
          attendants: "Agents",
        },
        nps: {
          score: "Score",
          promoters: "Promoters",
          neutrals: "Neutrals",
          detractors: "Detractors",
        },
        attendances: {
          total: "Total Attendances",
          waitingRating: "Attendances Waiting for Rating",
          withoutRating: "Attendances Without Rating",
          withRating: "Rated Attendances",
        },
        export: {
          attendantsReport: "AgentsReport",
          attendantsReportFileName: "agents-report.xlsx",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      audioRecorder: {
        recordButton: "Record Audio",
        recordingLabel: "Recording...",
        recordedLabel: "Audio recorded - {{time}}",
        recordedHelp: "Click ✓ to confirm or 🗑️ to delete",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        transferTickets: "Transfer Tickets",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        channel: "Channel",
        whatsappOfficial: "Official WhatsApp",
        connectNewAccount: "Connect new account",
        selectChannel: "Select the channel",
        pageName: "Page name",
        instagramHandle: "Instagram handle",
        badges: {
          linked: "Linked",
        },
        channelDescriptions: {
          whatsapp: "QR code and classic session management.",
          facebook: "Connect Facebook Pages and receive Messenger messages.",
          instagram: "Connect your business profile and centralize direct messages.",
        },
        steps: {
          stepOne: "Step 1",
          stepTwo: "Step 2",
          loginFacebook: "Log in to Facebook",
          selectPage: "Select the Page",
          selectInstagram: "Select the Instagram profile",
        },
        facebook: {
          success: "Facebook connection established successfully!",
        },
        transfer: {
          title: "Ticket Transfer",
          description: "To transfer tickets, select the",
          descriptionBold1: "source",
          descriptionMiddle: "connection (where tickets will be moved from) and the",
          descriptionBold2: "destination",
          descriptionEnd: "connection (where tickets will be transferred to). All active chats from the source connection will be moved to the destination connection.",
          origin: "Source",
          destination: "Destination",
          transferButton: "TRANSFER",
          cancel: "CANCEL",
          selectConnections: "Select source and destination connections",
          differentConnections: "Source and destination connections must be different",
          successMessage: "Tickets transferred successfully!",
          successMessageWithCount: "Transfer successful: {{count}} tickets transferred.",
          transferComplete: "Transfer completed!",
          transferError: "Error transferring tickets.",
          progressTitle: "Transferring Tickets",
          progressDescription: "Transfer Progress",
          progressMessage: "of",
          progressMessageEnd: "tickets transferred",
          progressWait: "Please wait while tickets are being transferred...",
          preDeleteTitle: "Ticket Transfer",
          preDeleteMessage: "Before deleting this connection, have you already transferred the tickets to another connection?",
          preDeleteNo: "NO",
          preDeleteYes: "YES",
        },
        syncTemplates: {
          tooltip: "Sync templates",
        },
        copyWebhook: {
          tooltip: "Copy webhook for Meta",
        },
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
          connect: "Connect",
          disconnectSocial: "Disconnect",
          loginWithFacebook: "Login with Facebook",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          channel: "Channel",
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "Number",
          color: "Color",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      contacts: {
        title: "Contacts",
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          ownerPhone: "Phone owner",
          actions: "Actions",
          lastMessage: "Last Message",
          wallet: "Wallet",
          status: "Status",
          photo: "Photo",
          id: "ID",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
          deleteAllContacts: "Delete All Contacts",
        },
        bulk: {
          selectAll: "Select all contacts",
          selected: "selected",
          allSelected: "(ALL)",
          deleteSelected: "Delete Selected",
          deleteAll: "Delete All",
          cancelSelection: "Cancel",
          noSelection: "Select at least one contact to delete",
        },
        modal: {
          profilePhoto: "Profile Photo",
          imageUnavailable: "Image unavailable",
          selectContact: "Select contact",
          blocked: "Blocked",
          active: "Active",
          notAssigned: "Not assigned",
          userNotFound: "User not found",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required",
          describeAI: "Describe the training for Artificial Intelligence",
          informVoiceMode: "Enter voice mode",
          informMaxTokens: "Enter maximum number of tokens",
          informTemperature: "Enter temperature",
          informApiKey: "Enter API Key",
          informQueue: "Enter queue",
          informMaxMessages: "Enter maximum number of messages",
          selectQueue: "Select sector",
        },
        voices: {
          text: "Text",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
        toasts: {
          permissionError: "This company does not have permission to access this page! We are redirecting you.",
        },
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        wallet: "Wallet",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          selectRotationType: "Select rotation type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
          none: "None",
          selectFile: "Select a File",
          minutes: {
            singular: "minute",
            plural: "minutes"
          }
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
          messageLabel: "Message:",
        },
        validation: {
          tooShort: "Too Short!",
          tooLong: "Too Long!",
          required: "Required",
          mustHaveFriends: "Must have friends",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
        integrationTypes: {
          dialogflow: "DialogFlow",
          n8n: "N8N",
          webhook: "WebHooks",
          typebot: "Typebot",
          flowbuilder: "Flowbuilder",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
          sendError: "Send Error",
        },
        subtitle: "Fill out the message, choose the destination, and schedule the send.",
        sections: {
          messageInfo: "Message Info",
          messageInfoDescription: "Write the message and quickly insert available variables.",
          destinationStatus: "Destination & Status",
          destinationStatusDescription: "Choose connection, ticket handling, assignee, and final status.",
          planning: "Scheduling / Recurrence",
          planningDescription: "Set the date, recurrence, and holiday behavior.",
        },
        variables: {
          title: "Available variables",
          helper: "Click to insert a variable",
        },
        validation: {
          messageTooShort: "Message too short",
          required: "Required",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
          assinarDescription: "Automatically append the signature to the scheduled message.",
          holidayMode: "Days",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
        toasts: {
          deleted: "Media deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete media",
          deleteMessage: "Are you sure you want to delete this media?",
        },
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        subtitle: "Create clean, recognizable tags to organize contacts and flows.",
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
        validation: {
          messageTooShort: "Message too short",
          required: "Required",
        },
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        search: {
          placeholder: "Search tickets and contacts"
        },
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
          all: "All",
          searchOnMessagesTooltip: "Check to also search in message content (slower)",
          ascending: "Ascending",
          descending: "Descending"
        },
        status: {
          open: "Open",
          pending: "Pending",
          group: "Group",
          closed: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        metaReplyWindow:
          "You have 24 hours to reply after receiving a message, according to Meta policies.",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Workflow Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Workflow",
          prompts: "Talk.AI",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
        },
        submenuLabels: {
          flowbuilder: "Automation Flow",
          flowCampaign: "Campaign Flow",
          flowConversation: "Conversation Flow",
        },
        tooltips: {
          expandMenu: "Expand menu",
          collapseMenu: "Collapse menu",
        },
        campaigns: {
          subMenus: {
            list: "List",
            listContacts: "Contact List",
            settings: "Settings",
          },
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        send: "Send",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        forbiddenMessage: "This company does not have permission to access this page! We are redirecting you.",
        successMessage: "Message sent successfully",
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
            endpoint: "Endpoint:",
            method: "Method:",
            headers: "Headers:",
            formData: "FormData:",
            file: "file",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
        openChat: "Open chat",
        newMessage: "New message",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        validation: {
          required: "Required",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
          attachMedia: "Attach Media",
          editMedia: "Edit media",
          removeMedia: "Remove media",
          newFile: "New File",
          newAudioRecorded: "New recorded audio",
          newAudio: "New Audio",
          chooseNewMediaToReplace: "Choose new media to replace:",
          chooseMediaOption: "Choose an option to attach media:",
          attachFile: "Attach File",
          recordAudio: "Record Audio",
          cancelEdit: "Cancel Edit",
          type: "Type",
          value: "Value",
          status: "Status",
          language: "Language",
          category: "Category",
          metaID: "Meta ID",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
          media: "Media",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
          downloadExample: "Download Example Spreadsheet",
          viewContacts: "View Contacts",
          edit: "Edit",
          delete: "Delete",
          selectAll: "Select all",
          deselectAll: "Deselect all",
        },
        modal: {
          selectContacts: "Select contacts",
        },
        emptySelection: "No contacts found.",
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
        summary: {
          totalLists: "Total lists",
          totalContacts: "Total contacts",
        },
        emptyState: {
          title: "No lists found",
          description: "Create your first contact list.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
          importFromContacts: "Import from contacts",
        },
        status: {
          valid: "WhatsApp valid",
          invalid: "WhatsApp invalid",
        },
        summary: {
          total: "Total",
          valid: "Valid",
          invalid: "Invalid",
        },
        emptyState: {
          title: "No contacts found",
          description: "Add or import contacts into this list.",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
          downloadExample: "Download the example spreadsheet.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Workflow",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
        sortOrder: "Sort by",
        ticketNumber: "Ticket Number",
        lastMessage: "Last Message",
        valueDesc: "Value (highest to lowest)",
        startDate: "Start date",
        endDate: "End date",
        search: "Search",
        addColumns: "+ Add columns",
        ticketPrefix: "Ticket #",
        assignValue: "Assign Value",
        value: "Value",
        remove: "Remove",
        viewTicket: "View Ticket",
        editValue: "Edit",
        saveValue: "Save",
        cancel: "Cancel",
        opportunityValue: "Opportunity Value",
        total: "Total",
        ticketUpdatedSuccess: "Ticket Tag updated successfully!",
        ticketRemovedSuccess: "Ticket Tag removed!",
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        dialog: {
          form: {
            whatsapp: "Connection",
            openTicket: "Open Ticket",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            statusTicket: "Ticket Status",
            closedTicketStatus: "Closed",
            openTicketStatus: "Open",
          },
        },
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
          recurrence: "Recurrence",
          nextExecution: "Next Execution",
        },
        toasts: {
          deleted: "Campaign deleted successfully!",
          cancel: "Campaign canceled successfully!",
          restart: "Campaign restarted successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be reversed.",
        },
        filters: {
          statusFilter: "Filter by Status",
          recurrenceFilter: "Filter by Recurrence",
          all: "All",
          allRecurrence: "All",
          inactive: "Inactive",
          scheduled: "Scheduled",
          inProgress: "In Progress",
          canceled: "Canceled",
          finished: "Finished",
          recurring: "Recurring",
          single: "Single",
        },
        quickActions: {
          title: "Quick actions",
        },
        legend: {
          show: "Show legend",
          hide: "Hide legend",
        },
        summary: {
          total: "Total",
          scheduled: "Scheduled",
          inProgress: "In progress",
          finished: "Finished",
          canceled: "Canceled",
          inactive: "Inactive",
        },
        emptyState: {
          title: "No campaigns found",
          description: "Try adjusting the filters or create a new campaign.",
        },
        recurrence: {
          title: "Recurrence",
          type: {
            daily: "Daily",
            weekly: "Weekly",
            biweekly: "Biweekly",
            monthly: "Monthly",
            yearly: "Yearly",
          },
          nextExecution: "Next Execution",
          executions: "executions",
          single: "Single",
          finished: "Recurrence finished",
          stopTitle: "Stop Recurrence",
          stopMessage: "Are you sure you want to stop the recurrence of this campaign? The current campaign will continue running, but there will be no more future executions.",
          stopSuccess: "Recurrence stopped successfully!",
        },
        status: {
          inactive: "Inactive",
          scheduled: "Scheduled",
          inProgress: "In Progress",
          canceled: "Canceled",
          finished: "Finished",
        },
        tooltips: {
          recurringCampaign: "Recurring Campaign",
          stop: "Stop Campaign",
          restart: "Restart Campaign",
          stopRecurrence: "Stop Recurrence",
          report: "Report",
          edit: "Edit",
          delete: "Delete",
        },
        noSchedule: "No schedule",
        notCompleted: "Not completed",
        listRemoved: "List removed",
        whatsappRemoved: "WhatsApp removed",
        notDefined: "Not defined",
        notDefinedFemale: "Not defined",
        enabled: "Enabled",
        disabled: "Disabled",
        tag: "Tag",
        permissionError: "This company does not have permission to access this page! We are redirecting you.",
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
        intervals: "Intervals",
        randomInterval: "Random Sending Interval",
        noBreak: "No Interval",
        intervalGapAfter: "Larger interval after",
        undefined: "Not defined",
        messages: "messages",
        laggerTriggerRange: "Larger sending interval",
        save: "Save",
        seconds: "seconds",
        forbiddenMessage: "This company does not have permission to access this page! We are redirecting you.",
        confirmDelete: "Are you sure you want to delete this variable?",
        deleteMessage: "This action cannot be undone.",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
          clickSave: "Click save to register the changes",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
          valorVenda: "Sale Value",
          motivoNaoVenda: "Reason for No Sale",
          finalizadoComVenda: "Closed with Sale",
          wallet: "Wallet",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
          exportExcel: "Export to Excel",
        },
        searchPlaceholder: "Search...",
        tooltips: {
          logsTicket: "Ticket Logs",
          accessTicket: "Access Ticket",
          exportExcel: "Export to Excel",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Opening Date",
            openTime: "Opening Time",
            closeDate: "Closing Date",
            closeTime: "Closing Time",
            supportTime: "Support Time",
            nps: "NPS",
            valorVenda: "Sale Value",
            motivoNaoVenda: "Reason for No Sale",
            finalizadoComVenda: "Closed with Sale",
          },
        },
        finalizadoComVenda: {
          sim: "Yes",
          nao: "No",
        },
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
        toasts: {
          deleted: "Integration deleted successfully!",
          permissionError: "This company does not have permission to access this page! We are redirecting you.",
        },
        validation: {
          tooShort: "Too Short!",
          tooLong: "Too Long!",
          required: "Required",
        },
        languages: {
          portuguese: "Portuguese",
          english: "English",
          spanish: "Spanish",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
          avatar: "Avatar",
        },
        buttons: {
          add: "Add User",
          generateExistingChats: "Generate Existing Chats",
        },
        summary: {
          total: "Total users",
        },
        emptyState: {
          title: "No users found",
          description: "Add your first user to get started.",
        },
        toasts: {
          deleted: "User deleted successfully.",
          chatCreated: "Chat created successfully!",
          chatsGenerated: "Chats generated successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
          generateInvoice: "Generate Invoice",
          currency: "Currency",
          noCompanies: "No companies found."
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          currency: "Currency",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        errors: {
          noPermission: "This company does not have permission to access this page! We are redirecting you.",
        },
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Workflow",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        summary: {
          total: "Total",
          contacts: "Contacts",
        },
        emptyState: {
          title: "No tags found",
          description: "Create your first tag.",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
        contactModal: {
          title: "Contacts",
          tableHeaders: {
            id: "ID",
            name: "Name",
            number: "Number",
            actions: "Actions",
          },
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        finalization: {
          title: "Service Finalization",
          generalConfig: "General Settings",
          askSaleValue: "Ask for sale value when finalizing service",
          askSaleValueHelper: "When enabled, the sale value field will appear in the finalization modal",
          reasonsTitle: "Finalization Reasons",
          addReason: "Add Reason",
          editReason: "Edit Reason",
          reasonName: "Reason Name",
          reasonDescription: "Description (optional)",
          cancel: "Cancel",
          saving: "Saving...",
          update: "Update",
          add: "Add",
          empty: "No reasons registered. Click \"Add Reason\" to start.",
          table: {
            name: "Name",
            description: "Description",
            actions: "Actions",
            noDescription: "No description"
          },
          toasts: {
            updateSuccess: "Settings updated successfully!",
            updateError: "Error updating settings",
            deleteError: "Error deleting reason"
          }
        },
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
            copyContactPrefix: "Contact Copy Prefix",
            copyContactPrefixPlaceholder: "Ex: COPY_",
            schedules: "Schedules",
            configurationPix: "Pix Efí Configuration (GerenciaNet)",
            mercadoPago: "Mercado Pago",
            stripe: "Stripe",
            asaas: "ASAAS",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            pixKey: "PIX Key",
            accessToken: "Access Token",
            stripePrivateKey: "Stripe Private Key",
            asaasToken: "Asaas Token",
            configurationCopyPrefix: "Contact Copy Prefix Configuration",
            successOperation: "Operation updated successfully.",
            text: "Text",
            finalizationAttendance: "Service Finalization"
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderPending:
          "Internal message (ticket awaiting acceptance)...",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
        internalMessageLabel: "Internal Message",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_USER_EMAIL_EXISTS: "A user with this email already exists.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Value",
        sendAsManyTimes: "Send as many times",
        shipNormallyOnNonbusinessDays: "Send also on holidays",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        title: "Invoices",
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
        pay: "PAY",
        paid: "PAID",
        expired: "Expired",
        open: "Open",
        attentionMessage: "Attention:",
        expiredWarning: "Your subscription has expired. Please contact support to regularize your situation.",
        summary: {
          total: "Total",
          open: "Open",
          paid: "Paid",
          expired: "Expired",
        },
        emptyState: {
          title: "No invoices found",
          description: "There are no invoices to display.",
        },
        yes: "Yes",
        no: "No",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
        accessTicket: "Access Ticket",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        chooseAStream: "Choose a stream",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Save Campaign",
        title: "Flow Campaigns",
        newCampaign: "New Campaign",
        editCampaign: "Edit campaign",
        deleteCampaign: "Delete campaign",
        deleteSuccess: "Campaign deleted successfully",
        noConnection: "No connection",
        connections: "Connections",
        active: "Active",
        disabled: "Disabled",
        nameNotDefined: "Name not defined",
        phrasesConfigured: "phrase(s) configured",
        noCampaignsFound: "No campaigns found",
        clickToCreateFirst: "Click on \"New Campaign\" to create your first flow campaign",
        moreConnections: "More",
        connection: "connection(s)",
        actions: "Actions",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
        audio: "[Audio]",
        image: "[Image]",
        video: "[Video]",
        file: "[File]",
        group: "Group",
        user: "User",
        errorLoadingUsers: "Error loading users",
        chatAlreadyExists: "Chat with this user already exists!",
        chatCreatedSuccess: "Chat created successfully!",
        errorCreatingChat: "Error creating chat",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
        errorCreatingEditingChat: "Error creating/editing chat",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          subtitle: "Create an internal group and quickly add participants",
          save: "Save",
          cancel: "Cancel",
          name: "Group name",
          description: "Description",
          filterUsers: "Search users to add",
          create: "Create",
          edit: "Edit",
        },
      },
      flowBuilder: {
        title: "Conversation Flows",
        titleWithCount: "Conversation Flows ({count})",
        searchPlaceholder: "Search flows...",
        newFlow: "New Flow",
        createFirstFlow: "Create First Flow",
        noFlowsFound: "No flows found",
        noFlowsCreated: "No flows created yet",
        tryOtherSearchTerms: "Try using other search terms",
        createFirstFlowDescription: "Create your first conversation flow to automate customer service",
        flowStatus: {
          active: "Active",
          inactive: "Inactive"
        },
        flowActions: {
          edit: "Edit",
          duplicate: "Duplicate",
          delete: "Delete",
          editFlow: "Edit flow",
          deleteFlow: "Delete flow"
        },
        confirmations: {
          deleteTitle: "Delete flow",
          deleteMessage: "This action cannot be undone. All related integrations will be lost.",
          duplicateTitle: "Duplicate flow",
          duplicateMessage: "A copy of the flow will be created for you to edit."
        },
        toasts: {
          flowDeleted: "Flow deleted successfully",
          flowDuplicated: "Flow duplicated successfully",
          flowCreated: "Flow created successfully",
          flowUpdated: "Flow updated successfully",
          errorDeleting: "Error deleting flow",
          errorDuplicating: "Error duplicating flow"
        },
        modal: {
          title: "Conversation Flow",
          newFlow: "New Flow",
          editFlow: "Edit Flow",
          flowName: "Flow Name",
          flowNamePlaceholder: "Enter flow name",
          save: "Save",
          cancel: "Cancel"
        }
      },
      flowBuilderConfig: {
        title: "Flow Editor",
        addNodes: "Add Nodes",
        startNode: {
          title: "Start of flow",
          description: "This block marks the start of your flow!"
        },
        categories: {
          basics: "Basics",
          content: "Content",
          interaction: "Interaction",
          logic: "Logic",
          system: "System",
          integrations: "Integrations"
        },
        nodes: {
          start: {
            name: "Start",
            description: "Flow starting point"
          },
          content: {
            name: "Content",
            description: "Send text, image, audio or video"
          },
          text: {
            name: "Text",
            description: "Simple text message"
          },
          menu: {
            name: "Menu",
            description: "Options menu for user"
          },
          input: {
            name: "Input",
            description: "Collect user input"
          },
          interval: {
            name: "Interval",
            description: "Pause execution for time"
          },
          randomizer: {
            name: "Randomizer",
            description: "Random path selection"
          },
          queues: {
            name: "Queues",
            description: "Manage service queues"
          },
          tags: {
            name: "Tags",
            description: "Add tags to contact"
          },
          removeTag: {
            name: "Remove Tag",
            description: "Remove tags from contact"
          },
          switchFlow: {
            name: "Switch Flow",
            description: "Change to another flow"
          },
          attendant: {
            name: "Attendant",
            description: "Transfer to attendant"
          },
          closeTicket: {
            name: "Close Ticket",
            description: "End service"
          },
          webhook: {
            name: "WebHook",
            description: "HTTP integration"
          },
          webform: {
            name: "Web Form",
            description: "Create web form"
          },
          variable: {
            name: "Variable",
            description: "Set global variables"
          },
          assign: {
            name: "Assign",
            description: "Assign chat to attendant"
          },
          openAI: {
            name: "OpenAI",
            description: "OpenAI integration"
          },
          gemini: {
            name: "Gemini",
            description: "Google Gemini integration"
          }
        },
        saveButton: "Save Flow",
        zoomIn: "Zoom In",
        zoomOut: "Zoom Out",
        flowSaved: "Flow saved successfully!",
        errorSaving: "Error saving flow",
        seconds: "sec",
        modals: {
          menu: {
            addTitle: "Add menu to flow",
            editTitle: "Edit menu",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          },
          text: {
            addTitle: "Add text to flow",
            editTitle: "Edit text",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          },
          interval: {
            addTitle: "Add interval to flow",
            editTitle: "Edit interval",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          },
          image: {
            addTitle: "Add image to flow",
            editTitle: "Edit image",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          },
          audio: {
            addTitle: "Add audio to flow",
            editTitle: "Edit audio",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          },
          video: {
            addTitle: "Add video to flow",
            editTitle: "Edit video",
            addButton: "Add",
            saveButton: "Save",
            cancelButton: "Cancel"
          }
        }
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Support Report",
        ticketId: "Ticket ID",
        client: "Customer",
        number: "Number",
        agent: "Agent",
        date: "Date",
        lastMessage: "Last Message",
        fullReport: "The full report is attached above",
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        elementNotFoundForExport: "Element not found for export.",
        reportFilename: "support_report",
      },
    },
    salesReport: {
      title: "Sales Report",
      filters: {
        startDate: "Start Date",
        endDate: "End Date",
        user: "User",
        allUsers: "All users",
        search: "Search"
      },
      table: {
        attendant: "Attendant",
        date: "Date",
        saleValue: "Sale Value",
        noSaleReason: "No Sale Reason",
        finalizationReason: "Finalization Reason",
        totalSales: "Total Sales",
        totalSalesValue: "Total Sales Value",
        totalTickets: "Total Tickets",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues"
      }
    },
    placeholders: {
      chooseFlow: "Choose a flow",
      filterByTags: "Filter by Tags",
      departments: "Departments",
      searchTemplates: "Search Templates",
      emailAddress: "Email address",
      contacts: "Contacts",
      tags: "Tags",
      users: "Users",
      azureSpeechKey: "Azure Speech Service Key",
      search: "Search",
      selectOption: "Select an option",
      typeHere: "Type here",
      enterValue: "Enter value",
      selectDate: "Select date",
      chooseFile: "Choose file"
    },
    validation: {
      required: "Required",
      invalidEmail: "Invalid email",
      tooShort: "Too short",
      tooLong: "Too long",
      minLength: "Minimum {{min}} characters",
      maxLength: "Maximum {{max}} characters",
      requiredField: "Required field",
      apiKeyRequired: "API Key is required",
      voiceModeRequired: "Voice mode is required",
      voiceKeyRequired: "Voice Key is required for voice synthesis",
      voiceRegionRequired: "Voice Region is required for voice synthesis",
      keywordEmpty: "Keyword cannot be empty",
      goalRequired: "Goal is required when auto-complete is active",
      ratingRequired: "Rating is required"
    },
    toasts: {
      common: {
        error: "Error processing request",
        success: "Operation completed successfully",
        loading: "Loading...",
        warning: "Warning",
        info: "Information"
      },
      finalizacaoVenda: {
        informValue: "Please enter the sale amount",
        ticketFinalized: "Ticket successfully finalized!",
        errorFinishing: "Error finalizing ticket"
      },
      flowBuilder: {
        tagRemoved: "Tag removed successfully!",
        selectTag: "Select a tag to remove",
        nodeAdded: "Node added to flow",
        nodeRemoved: "Node removed from flow",
        flowSaved: "Flow saved successfully",
        errorSaving: "Error saving flow"
      },
      tickets: {
        finalized: "Ticket successfully finalized!",
        errorFinalizing: "Error finalizing ticket",
        transferred: "Ticket transferred successfully",
        errorTransferring: "Error transferring ticket",
        accepted: "Ticket accepted successfully",
        errorAccepting: "Error accepting ticket"
      },
      settings: {
        noPermission: "No permission to access!",
        saved: "Settings saved successfully",
        errorSaving: "Error saving settings",
        fileRequired: "Please choose a file!",
        destinationRequired: "Please choose a destination!",
        fileSent: "File sent successfully!",
        errorSending: "Error sending file",
        invalidFormat: "Only p12 format files are allowed!"
      },
      connections: {
        created: "Connection created successfully",
        updated: "Connection updated successfully",
        deleted: "Connection deleted successfully",
        errorCreating: "Error creating connection",
        errorUpdating: "Error updating connection",
        errorDeleting: "Error deleting connection"
      },
      campaigns: {
        created: "Campaign created successfully",
        updated: "Campaign updated successfully",
        deleted: "Campaign deleted successfully",
        started: "Campaign started successfully",
        paused: "Campaign paused successfully",
        errorCreating: "Error creating campaign",
        errorUpdating: "Error updating campaign",
        errorDeleting: "Error deleting campaign"
      },
      contacts: {
        imported: "Contacts imported successfully",
        exported: "Contacts exported successfully",
        deleted: "Contact deleted successfully",
        errorImporting: "Error importing contacts",
        errorExporting: "Error exporting contacts",
        errorDeleting: "Error deleting contact"
      },
      dashboard: {
        createdTickets: "Created Tickets"
      }
    },
    dialogs: {
      announcements: "Announcements",
      chooseColor: "Choose a color",
      finalizationValue: "Service Finalization - Sale Value",
      editNote: "Edit Note",
      editMessage: "Edit Message",
      forwardMessage: "Forward Message",
      chooseOption: "Choose an option",
      editBodyRequest: "Edit request body",
      fullApiResponse: "Full API response",
      loadingSettings: "Loading settings...",
      templateDetails: "Selected Template Details",
      selectedTemplate: {
        name: "Name",
        content: "Content",
        language: "Language",
        category: "Category"
      }
    },
    forms: {
      labels: {
        openaiModel: "OpenAI Model",
        geminiModel: "Gemini Model",
        responseType: "Response Type",
        operationMode: "Operation Mode",
        selectChat: "Select chat",
        selectCurrency: "Select Currency",
        attendant: "Attendant",
        noSaleReason: "No Sale Reason",
        finalizationReason: "Finalization Reason",
        chooseAttendant: "Choose an attendant",
        whatsappConnections: "WhatsApp Connections",
        type: "Type",
        campaigns: "Campaigns",
        sendAsRecordedAudio: "Send as recorded audio",
        noSales: "No Sales",
        welcomeFlow: "Welcome flow",
        defaultResponseFlow: "Default response flow"
      }
    },
    flowDefaults: {
      welcomeFlowDescription: "This flow is triggered only for new contacts—people you don’t have in your contact list and who sent a message.",
      defaultResponseFlowDescription: "The default response is sent for any character that is not a keyword. ATTENTION! It will trigger if the ticket is already closed."
    }
  },
};

export { messages };
